import { RouterModule } from '@angular/router';
import { MediaCardFooterComponent } from "./media-card-footer/media-card-footer.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MediaCardComponent } from "./media-card.component";
import { IconModule } from "../icon/icon.module";
import { TransitionModule } from "../transition/index";
import { ButtonModule } from "../button/button.module";
import { CardModule } from "../card/card.module";
import { MenuModule } from "../menu/menu.module";
import { CaptionModule } from "../caption/caption.module";
import { TagModule } from "../tag/tag.module";

@NgModule({
	declarations: [MediaCardComponent, MediaCardFooterComponent],
	imports: [
		CommonModule,
		TransitionModule,
		IconModule,
		ButtonModule,
		CardModule,
		MenuModule,
		CaptionModule,
		TagModule,
		IconModule,
		RouterModule
	],
	exports: [MediaCardComponent, MediaCardFooterComponent]
})
export class MediaCardModule { }
